var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3335 13.1856C10.2449 13.28 10.1248 13.333 9.99953 13.333C9.87428 13.333 9.75416 13.28 9.66559 13.1856L5.13782 8.3587C5.07198 8.28829 5.02716 8.19867 5.00902 8.10114C4.99088 8.00361 5.00023 7.90254 5.0359 7.81066C5.07156 7.71879 5.13194 7.64023 5.20942 7.58489C5.2869 7.52955 5.37802 7.49989 5.47129 7.49967L14.5268 7.49968C14.6204 7.4995 14.7118 7.52893 14.7897 7.58425C14.8675 7.63957 14.9282 7.71827 14.964 7.81039C14.9998 7.90251 15.0092 8.0039 14.9909 8.10169C14.9726 8.19949 14.9275 8.28929 14.8612 8.35971L10.3335 13.1856Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron2);
export default __webpack_public_path__ + "static/media/Chevron2.e7bc4ae5b752f1ff49a3ad17b0e4e9a2.svg";
export { ForwardRef as ReactComponent };